import React from 'react';

export const StepperContext = React.createContext({});
